module.exports = __webpack_public_path__ + "media/src/admin/images/logo-aadf05fcd060e9200fb35d3e60be3abb.png";